import React, { useState, useCallback } from "react"
import styled, { css } from 'styled-components'
import { useSpring, animated as a } from 'react-spring'
import { theme } from '../../../GlobalStyle'

const StyledLinkButton = styled(a.a)`
  ${({ theme: { color }}) => css`
    display: inline-block;
    &:hover {
      color: ${color.grey}
    }
  `}
`

const LinkButton = ({ children, ...props }) => {

  const [isHover, setIsHover] = useState(false)
  const { color } = useSpring({
    color: isHover ? theme.color.grey : theme.color.accent
  })

  const handleMouseEnter = useCallback(() => {
    setIsHover(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setIsHover(false)
  }, [])

  return (
    <StyledLinkButton
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ color }}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </StyledLinkButton>
  )
}

export default LinkButton